// Why a reservation left the report (row field cancel_source). Unknown is a real answer, not a gap:
// attribution is only recorded from PAUL-3458 on and the backfill reached telemetry retention only, so
// older cancels keep it permanently. Never render an actor for Unknown.
export enum MaccsBoxCancelSource {
  Unknown = 0,
  Portal = 1,
  Staff = 2,
  System = 3,
  Refund = 4,
}

// The clause appended after the status label. Partial, and Unknown is absent on purpose: looking it up
// must come back undefined so the caller renders the status on its own.
export const maccsBoxCancelSourceTranslations: Partial<Record<MaccsBoxCancelSource, string>> = {
  [MaccsBoxCancelSource.Portal]: 'maccsbox_reports.tickets.cancel_source.portal',
  [MaccsBoxCancelSource.Staff]: 'maccsbox_reports.tickets.cancel_source.staff',
  [MaccsBoxCancelSource.System]: 'maccsbox_reports.tickets.cancel_source.system',
  [MaccsBoxCancelSource.Refund]: 'maccsbox_reports.tickets.cancel_source.refund',
};
